import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssigneeSelect from "../../../../board/client-profile/components/shared/assignee-select";
import MaterialInput from "@Shared/components/inputs/material-input";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { DEFAULT_ASSIGNEES_USERNAMES, CLIENT_PROFILE_OWNER } from "@Broker/@Modules/clients/board/store/board-getters";
import { mapGetters, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { validDate, futureDate } from "@Shared/@Utils/validation-rules";
import TimeInput from "../../../../../automation/automation/components/argument-types/time";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "QuickActions",
  components: {
    AssigneeSelect,
    MaterialInput,
    TimeInput,
    DatepickerInput
  },
  mixins: [validationMixin],
  props: {
    wrapInputs: {
      type: Boolean,
      default: false
    },
    clientProfileId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      noteDescription: "",
      quickFollowUp: {
        scheduledDate: "",
        scheduledTime: "",
        description: "",
        assignees: []
      }
    };
  },
  validations: {
    quickFollowUp: {
      scheduledDate: {
        required,
        validDate,
        futureDate
      },
      scheduledTime: {
        required
      },
      description: {
        required
      }
    },
    noteDescription: {
      required
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapFields("AccountStore", ["accountPreferences.followUpNotificationTime"])), mapState("BoardStore", ["selectedBoardId"])), mapGetters("BoardStore", [DEFAULT_ASSIGNEES_USERNAMES, CLIENT_PROFILE_OWNER])), {}, {
    defaultAssigneesUsername() {
      return this.DEFAULT_ASSIGNEES_USERNAMES(this.selectedBoardId, this.clientProfileId);
    },
    validQuickFollowUp() {
      return !this.$v.quickFollowUp.$invalid;
    },
    validQuickNote() {
      return !this.$v.noteDescription.$invalid;
    }
  }),
  watch: {
    quickFollowUp: {
      deep: true,
      handler() {
        this.updateFollowup();
      }
    },
    noteDescription: {
      deep: true,
      handler() {
        this.updateNote();
      }
    },
    validQuickNote(value) {
      this.handleValidationChange("note", value);
    },
    validQuickFollowUp(value) {
      this.handleValidationChange("follow-up", value);
    }
  },
  mounted() {
    this.quickFollowUp.scheduledTime = this.followUpNotificationTime;
    this.resetAssignees();
  },
  methods: {
    updateFollowup() {
      this.$emit("change", "follow-up", this.quickFollowUp);
    },
    updateNote() {
      this.$emit("change", "note", this.noteDescription);
    },
    handleNotifyChange(data, type) {
      var _context2;
      if (type === "select") data.forEach(option => {
        var _context;
        if (!_includesInstanceProperty(_context = this.quickFollowUp.assignees).call(_context, option.username)) this.quickFollowUp.assignees.push(option.username);
      });else if (type === "unselect") this.quickFollowUp.assignees = _filterInstanceProperty(_context2 = this.quickFollowUp.assignees).call(_context2, username => username !== data.username);
    },
    resetAssignees() {
      this.quickFollowUp.assignees = this.defaultAssigneesUsername;
    },
    handleValidationChange(type, isValid) {
      this.$emit("validation-change", type, isValid);
    }
  }
});